import React from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'loda... Remove this comment to see the full error message
import _ from 'lodash';
import {
  Table as MuiTable, TableBody, TableCell, TableHead, TableRow
} from '@material-ui/core';
import EmptyState from './EmptyState';

/*
columns = [
  {
    title: 'Meow',
    cellProps: {
      herp: 'derp'
    },
    cellContent: (result, index) => <Meow cat={result} />
  }
]
 */
const Table = ({
  data,
  columns
}: any) => {
  if (_.isEmpty(data)) return <EmptyState />;

  return (
    <MuiTable>
      <colgroup>
        {columns.map(({
          width
        }: any, i: any) => <col key={i} width={width} />)}
      </colgroup>
      {
        columns.filter((col: any) => col.title).length ? (
          <TableHead>
            <TableRow>
              {
                columns.map(({
                  title,
                  cellProps
                }: any) => (
                  <TableCell {...cellProps}>
                    {title}
                  </TableCell>
                ))
              }
            </TableRow>
          </TableHead>
        ) : null
      }
      <TableBody>
        {
          data.map((result: any, index: any) => (
            <TableRow
              hover
              key={result.id}
            >
              {
                columns.map(({
                  cellContent,
                  cellProps
                }: any) => (
                  <TableCell {...cellProps}>
                    {cellContent(result, index)}
                  </TableCell>
                ))
              }
            </TableRow>
          ))
        }
      </TableBody>
    </MuiTable>
  );
};

export default Table;
